import { fmtDay, fmtRange, fmtWeekday, fromIso, monthShort, toIso, weekdayShort } from '../../../@services/dates'

/** Header of a column: `{ label, sub, title, isToday, first, last, isWeek }` */
export function columnHeader(column, by, today) {
	const dates = (column.dates || []).map(fromIso).filter(Boolean)
	const first = dates[0], last = dates[dates.length - 1]
	const todayIso = toIso(today)
	const isToday = (column.dates || []).includes(todayIso)
	if (by === 'week') {
		const week = Number(String(column.key).slice(4))
		return { label: fmtDay(first, false), sub: `Week ${week}`, title: `Pick-ups ${fmtRange(first, last)}`, isToday, first, last, isWeek: true }
	}
	return {
		label: `${weekdayShort(first)} ${first.getDate()}`,
		sub: `${monthShort(first)}${first.getFullYear() !== today.getFullYear() ? ' ' + first.getFullYear() : ''}`,
		title: fmtWeekday(first), isToday, first, last, isWeek: false,
	}
}
